// components/UrlInput.js
// Propósito: Entrada y botón para iniciar análisis.
// Por qué: Aíslamos la validación de la URL y el envío.

import React, { useState } from 'react';

const URL_REGEX = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i; // Simplificado

function UrlInput({ onAnalyze }) {
  const [url, setUrl] = useState('');
  const [error, setError] = useState(null);

  function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    const value = url.trim();
    if (!value || !URL_REGEX.test(value)) {
      setError('Ingrese una URL válida que comience con http(s)://');
      return;
    }
    onAnalyze?.(value);
  }

  return (
    <form onSubmit={handleSubmit} className="row g-3 align-items-end glass-card url-form">
      <div className="col-md-9">
        <label htmlFor="url" className="form-label text-light">URL a analizar</label>
        <input
          id="url"
          type="url"
          className="form-control glass-input"
          placeholder="https://example.com"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        {error && <div className="form-text text-danger">{error}</div>}
      </div>
      <div className="col-md-3 d-grid">
        <button type="submit" className="btn btn-primary btn-glow" disabled={!url.trim()}>
          Analizar
        </button>
      </div>
    </form>
  );
}

export default UrlInput;
